<template>

  <div class="container">
    <h3 class="main-title">Anexos</h3>
    <form novalidate>
      <fieldset>
        <div class="row row-responsive">
          <div class="column column-xs-100 column-sm-50">
            <label for="monthlyAmount">Selecciona el anexo a firmar:</label>
          </div>
          <div class="column column-xs-100 column-sm-50">
             <span class="select">
              <select v-model="annexSelected" :disabled="annexesList.length === 0" @change="getAnnexPreview()">
                <option value="" disabled selected>Seleccione:</option>
                <option v-for="annex in annexesList" :key="annex.id" :value="annex.id">
                  {{ annex.annex__name }}
                </option>
              </select>
              <span class="arrow"></span>
            </span>
          </div>
        </div>
      </fieldset>
      <div class="row row-responsive">
        <div class="column column-xs-100">
          <div class="box-annex" v-html="annexHTML"></div>
          <div class="box-sign" v-if="rawHTML !== ''">
            <label class="input checkbox float-left">Leí y acepto este anexo de contrato
              <input type="checkbox" v-model="annexSign" />
              <div class="indicator"></div>
            </label>
            <button class="button float-right" :disabled="annexSign === false" @click.prevent="signAnnex()">Firmar anexo</button>
          </div>
        </div>
      </div>
      <div class="row row-responsive">
        <div class="column column-xs-100">
          <p class="title -centered-info" v-if="annexesAllSigned"><b>Ya has firmado todos los anexos, puedes seguir al siguiente paso.</b></p>
          <button class="button float-right" :disabled="annexesAllSigned === false" @click.prevent="nextStep()">Siguiente</button>
        </div>
      </div>
    </form>
  </div>

</template>

<script>

import mixins from '@/mixins/index'
import userProfileMixin from '@/mixins/userProfileMixin'
import httpRequestMixin from '@/mixins/httpRequestMixin'

export default {
  name: 'StepAnnex',
  data () {
    return {
      rawHTML: '',
      annexesList: [],
      annexSelected: '',
      annexesAllSigned: false,
      annexSign: true
    }
  },
  computed: {
    annexHTML: function () {
      const parsedstr = new DOMParser().parseFromString(
        this.rawHTML, 'text/html')
      return parsedstr.documentElement.textContent
    }
  },
  mixins: [mixins, userProfileMixin, httpRequestMixin],
  methods: {
    getContractsToSign: async function () {
      this.annexesList = []
      this.annexSelected = ''

      await this.$store.dispatch('refreshToken')
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/annex-to-sign/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`
        }
      }
      const response = await this.httpRequest(options)
      if (response) {
        switch (response.status) {
          case 200:
          case 201:
            this.annexesList = response.data.versions
            if (response.data.versions.length === 0) {
              this.annexesAllSigned = true
            }
            break
          case 202:
            this.modalError(response.data.error, 'warning')
            break
          default:
            break
        }
      }
    },
    getAnnexPreview: async function () {
      let options = {
        method: 'POST',
        url: process.env.AUTH_BASE + '/annex-preview/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`
        },
        data: {
          annex_version: this.annexSelected
        }
      }
      const response = await this.httpRequest(options)
      if (response) {
        switch (response.status) {
          case 200:
          case 201:
            this.rawHTML = response.data.html
            this.doScroll(230)
            break
          case 202:
            this.modalError(response.data.error, 'warning')
            break
          default:
            break
        }
      }
    },
    signAnnex: async function () {
      let options = {
        method: 'POST',
        url: process.env.AUTH_BASE + '/annexes/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`
        },
        data: {
          annex_version: this.annexSelected
        }
      }
      const response = await this.httpRequest(options)
      if (response) {
        switch (response.status) {
          case 200:
          case 201:
            this.doScroll()
            this.rawHTML = ''
            this.getContractsToSign()
            break
          case 202:
            this.modalError(response.data.error, 'warning')
            break
          default:
            break
        }
      }
    }
  },
  created: function () {
    setTimeout(() => {
      this.getContractsToSign()
    }, 2000)
  }
}
</script>

<style lang="scss" scoped>

.box-annex {
  background-color: $white;
}

</style>



// WEBPACK FOOTER //
// src/views/userProfile/profileSteps/StepAnnex.vue